import React from 'react'
import image from './logo.png'
import Footer from './footer'

export default function Heading() {
    return (
        <>
            <div className="main"><br />
                <img src={image} alt="" style={{ height: '200px', width: '200px', margin: 'auto', display: 'block' }} />
                <h1 style={{ textAlign: 'center', color: 'white', fontFamily: 'Times New Roman', WebkitTextStroke: '2px', animation: 'heading 0.5s infinite alternate' }}>Web Blog</h1><br /><br />
                <h3 style={{ textAlign: 'center', color: "orange", fontFamily: 'Times New Roman', WebkitTextStroke: '1px' }}>Stay connected to know more about web development</h3>
                <div className="main2">
                    <a href="/about">
                        <button className='btn btn-primary'>About</button>
                    </a>
                    <a href="/contacts.js">
                        <button className='btn btn-primary'>Contact</button>
                    </a>
                </div><br /><br />
            </div>
        </>
    )
}